import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Loader from "../loader/loader";
import staffService from "../../api/services/staffService";
import ListItem from "./ListItem";

function DeletedUserList() {
  const [staffList, setStaffList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [isModalVisible, setModal] = useState(-1);

  useEffect(() => {
    onPageInit(0);
  }, []);

  const onPageInit = async (offset) => {
    const resp = await staffService.getAllPartners({
      limit: 40,
      offset: offset,
      status:'deleted'
    });
    if (resp?.data?.length > 0) {
      const localData = offset === 0 ? resp.data : [...staffList, ...resp.data];
      setStaffList(localData);
      setIsLoading(false);
      setShowLoadMore(resp?.data?.length === 40);
    }
  };

  const toggle = () => setModal(-1);
  
  const onRestoreClick = (index) => {
    setModal(index);
  };

  const onRestoreModalClick = async () => {
    setIsLoading(true);
    const resp = await staffService.restorePartner({
      partnerID: staffList[isModalVisible].PARTNERID
    });
    if(resp.success){
      toggle();
      onPageInit(0);
    }
  };

  return (
    <Card>
      <Loader isLoading={isLoading} />
      <CardTitle className="border-bottom p-3 mb-0 font-weight-bold text-uppercase">
        <i class="fas fa-users-cog"></i>
        Deleted Users
      </CardTitle>
      <CardBody>
        <table className="table stylish-table mb-0 mt-2 no-wrap v-middle">
          <thead>
            <tr>
              <th className=" font-weight-bold text-muted border-0 border-bottom">
                Name
              </th>
              <th className=" font-weight-bold text-muted border-0 border-bottom">
              Email address
              </th>
              <th className=" font-weight-bold text-muted border-0 border-bottom">
                Description
              </th>
              <th className=" font-weight-bold text-muted border-0 border-bottom">
                Give Back Percent
              </th>
              <th className=" font-weight-bold text-muted border-0 border-bottom">
                Status
              </th>
              <th className=" font-weight-bold text-muted border-0 border-bottom">
                Restore
              </th>
            </tr>
          </thead>
          <tbody>
            {staffList.map((user, index) => (
              <ListItem
                user={user}
                setStaffList={setStaffList}
                index={index}
                showActions={false}
                onRestoreClick={onRestoreClick}
                showRestore={true}
              />
            ))}
          </tbody>
        </table>
        {showLoadMore && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: 8,
            }}
          >
            <Button
              color="primary"
              onClick={() => onPageInit(staffList.length)}
            >
              Load More
            </Button>
          </div>
        )}
      </CardBody>

      <Modal isOpen={isModalVisible > -1} toggle={toggle}>
        <ModalHeader toggle={toggle}>Restore Account</ModalHeader>
        <ModalBody>Are you sure, you want to restore this account?</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onRestoreModalClick}>
            Yes
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
}

export default DeletedUserList;
